import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerModelloF23F24ModalComponent} from './worker-modello-f23-f24-modal';

export const WorkerModelloF23F24ModalModule: string = ng
    .module('worker-modello_f23_f24-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerModelloF23F24ModalComponent', WorkerModelloF23F24ModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-modello-f23-f24-modal/worker-modello-f23-f24-modal.module.ts